{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "อีเมล์",
      "PLACEHOLDER": "กรุณากรอกอีเมล์ของคุณ.",
      "ERROR": "กรุณากรอกอีเมล์ให้ถูกต้อง."
    },
    "API": {
      "SUCCESS_MESSAGE": "ลิ้งกู้หรัสผผ่านถูกส่งไปยังอีเมล์ของคุณเเล้ว.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "SUBMIT": "ส่ง"
  }
}
